export function CurrentUrlBadge() {
  return (
    <div className="mt-6 inline-flex max-w-full items-center gap-1 self-start overflow-hidden rounded-full bg-tiga-surface-lightest px-3 py-2 text-xs text-tiga-text-lighter">
      <span className="shrink-0 font-medium tracking-wide text-tiga-text-lighter uppercase opacity-50 select-none">
        URL
      </span>
      <span className="truncate font-mono whitespace-nowrap">
        {globalThis.location.pathname}
        {globalThis.location.search}
      </span>
    </div>
  );
}
